import { TableConfiguration } from 'src/common/components/Sim/Inventory/constants/columnConfigurationsConstants';
import {
  revertSimProductsTableConfiguration,
  saveSimProductTableConfiguration,
} from '../../../api/simProductsTableConfigurationApi';

import { simProductsQueries } from '../../../queries/simProductsQueries';
import { useConfigurationActions } from 'src/common/components/Sim/Inventory/hooks/useConfigurationActions';

export const useSimProductsConfigurationActions = (configuration: TableConfiguration) => {
  return useConfigurationActions({
    configuration,
    saveConfiguration: saveSimProductTableConfiguration,
    revertConfiguration: revertSimProductsTableConfiguration,
    refetchQueryKey: simProductsQueries.all,
  });
};
